// import { TextField } from "@mui/material";
// import { useContext, useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { AiFillPlusCircle } from "react-icons/ai";
// import { FaTrash } from "react-icons/fa";
// import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { CreateContactFinep, CreateContactPhoneFinep, DeleteContactPhoneFinep, EditContactFinep, GetAllContactPhone, GetContactFinepByCompanyAndReference } from "../../API/OfficialContactAPI";
// import { ContactPhoneFinepModel, ContactBaseModel } from "../../Models/ContactPhoneFinepModel";
// import { useAuth } from "../../Hooks/useAuth";
// import Loader from "../Shared/Loader";
// import { CompanyFinepContext } from "../../Contexts/CompanyFinepContext";

// interface ContactPartialProps {
//     type: 'officialContact' | 'financialContact';
//     setValidateField: React.Dispatch<React.SetStateAction<boolean>>
// }

// const ContactPartial = ({ type, setValidateField }: ContactPartialProps) => {
//     const [loading, setLoading] = useState(false);

//     const [number, setNumber] = useState("");

//     const [contacts, setContacts] = useState<ContactPhoneFinepModel[]>([]);

//     const { handleFillTab, handleValidateTab } = useContext(CompanyFinepContext);

//     const user = useAuth();
//     const { companyId } = useParams();

//     const referenceNumber = type === 'officialContact' ? 0 : 1;

//     const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm<ContactBaseModel>({
//         defaultValues: {
//             department: '',
//             email: '',
//             fullName: '',
//             setor: '',
//             companyFinepId: companyId,
//             userEmail: user.userEmail,
//             reference: referenceNumber,
//             contactPhone: 0,
//             isContentValid: false
//         }
//     });

//     useEffect(() => {
//         getContacts();
//     }, [])

//     async function getContacts() {
//         setLoading(true);

//         if (companyId) {
//             await GetContactFinepByCompanyAndReference(companyId, referenceNumber)
//                 .then((x: ContactBaseModel) => {
//                     if (x) {
//                         handleFillTab(2);

//                         if(x.isContentValid)
//                         {
//                             handleValidateTab(2, 2);
//                             setValidateField(true);
//                         }

//                         setValue('id', x.id);
//                         setValue('companyFinepId', x.companyFinepId);
//                         setValue('department', x.department);
//                         setValue('fullName', x.fullName);
//                         setValue('email', x.email);
//                         setValue('isContentValid', x.isContentValid);
//                         setValue('reference', x.reference);
//                         setValue('setor', x.setor);
//                         setValue('contactPhone', x.contactPhone);

//                         GetAllContactPhone(x.id ?? "")
//                             .then(x => setContacts(x))
//                             .catch(x => setLoading(false));
//                     }
//                 })
//                 .catch(x => setLoading(false));
//         }

//         setLoading(false);
//     }


//     async function handleAddContact() {
//         setLoading(true);

//         if (number === "") {
//             toast.error("Por favor, insira o campo Número para continuar");
//             return;
//         }

//         const contact: ContactPhoneFinepModel = {
//             phoneNumber: number,
//             contactFINEPId: getValues('id'),
//             isDefault: false,
//             userEmail: user.userEmail,
//             reference: 0,
//         };

//         await CreateContactPhoneFinep(contact)
//             .then(x => contact.id = x.data.id)
//             .catch(x => setLoading(false));

//         setContacts([...contacts, contact]);
//         setNumber("");

//         setLoading(false);
//     }

//     async function handleRemoveContact(id: string) {
//         setLoading(true);


//         setContacts((prevList) => {
//             const filteredList = contacts.filter(x => x.id != id);

//             return filteredList;
//         });

//         await DeleteContactPhoneFinep(id)
//             .catch(x => setLoading(false));

//         setLoading(false);
//     }

//     async function handleSubmitContactPhone(data: ContactBaseModel) {
//         setLoading(true);

//         data.isContentValid = true;
//         data.companyFinepId = companyId;
//         data.contactPhone = 12

//         if (getValues('id')) {
//             await EditContactFinep(data)
//                 .catch(x => setLoading(false));
//         }
//         else {
//             await CreateContactFinep(data)
//                 .then(x => setValue('id', x.data.id))
//                 .catch(x => setLoading(false));

//             handleFillTab(2)
//         }

//         setLoading(false)
//     }

//     return (
//         <>
//             {loading && <Loader />}
//             <form onSubmit={handleSubmit(handleSubmitContactPhone)}>
//                 <div className="d-flex mt-4">
//                     <TextField
//                         type="text"
//                         label="Nome Completo"
//                         placeholder="Digite o nome completo"
//                         className="w-100 me-4"
//                         {...register('fullName')}
//                         required
//                         onBlur={handleSubmit(handleSubmitContactPhone)}
//                     />
//                     <TextField
//                         type="email"
//                         label="E-mail"
//                         className="w-50 me-4"
//                         {...register('email')}
//                         required
//                         onBlur={handleSubmit(handleSubmitContactPhone)}
//                     />
//                     <TextField
//                         type="text"
//                         label="Cargo"
//                         className="w-50 me-4"
//                         {...register('setor')}
//                         required
//                         onBlur={handleSubmit(handleSubmitContactPhone)}
//                     />
//                     <TextField
//                         type="text"
//                         label="Departamento"
//                         placeholder="Digite o departamento"
//                         className="w-50 me-4"
//                         {...register('department')}
//                         onBlur={handleSubmit(handleSubmitContactPhone)}
//                     />
//                 </div>
//                 {getValues('id') &&
//                     <div className="w-50 d-flex mt-4 align-items-center">
//                         <TextField
//                             type="number"
//                             label="Telefone"
//                             placeholder="Digite o telefone"
//                             className="w-50 me-4"
//                             onChange={(e) => setNumber(e.target.value)}
//                             value={number}
//                         />
//                         <AiFillPlusCircle className="cursor-pointer" size={40} onClick={handleAddContact} />
//                     </div>
//                 }
//                 {contacts.map((contact, index) => {
//                     return (
//                         <div key={index} className="w-75 d-flex mt-4 align-items-center mb-4">
//                             <TextField
//                                 type="number"
//                                 label="Telefone"
//                                 variant="filled"
//                                 placeholder="Digite o telefone"
//                                 className="w-50 me-4"
//                                 disabled
//                                 value={contact.phoneNumber}
//                             />
//                             <FaTrash className="cursor-pointer" size={30} onClick={() => handleRemoveContact(contact.id ?? "")} />
//                         </div>
//                     )
//                 })}
//             </form>
//         </>

//     );
// }

// export default ContactPartial;














import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    CreateContactFinep,
    CreateContactPhoneFinep,
    DeleteContactPhoneFinep,
    EditContactFinep,
    GetAllContactPhone,
    GetContactFinepByCompanyAndReference
} from "../../API/OfficialContactAPI";
import { ContactPhoneFinepModel, ContactBaseModel } from "../../Models/ContactPhoneFinepModel";
import { useAuth } from "../../Hooks/useAuth";
import { CompanyFinepContext } from "../../Contexts/CompanyFinepContext";
import { Table, Input, Button, Form, Space, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, PlusCircleOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import Loader from "../Shared/Loader";
interface ContactPartialProps {
    type: "officialContact" | "financialContact";
    setValidateField: React.Dispatch<React.SetStateAction<boolean>>;
}
interface ContactWithPhone extends ContactBaseModel {
    phoneNumber: string;
    id?: string;
    isEditing?: boolean;
    isNew?: boolean;
}
const ContactPartial = ({ type, setValidateField }: ContactPartialProps) => {
    const [loading, setLoading] = useState(false);
    const [contacts, setContacts] = useState<ContactWithPhone[]>([]);
    const [newContact, setNewContact] = useState<ContactWithPhone>({
        fullName: "",
        email: "",
        setor: "",
        department: "",
        phoneNumber: "",
        companyFinepId: "",
        userEmail: "",
        reference: type === "officialContact" ? 0 : 1,
        isContentValid: false,
        contactPhone: 0,
        isNew: true
    });
    const { handleFillTab, handleValidateTab } = useContext(CompanyFinepContext);
    const user = useAuth();
    const { companyId } = useParams();
    useEffect(() => {
        if (companyId && user.userEmail) {
            setNewContact(prev => ({
                ...prev,
                companyFinepId: companyId,
                userEmail: user.userEmail
            }));
            getContacts();
        }
    }, [companyId, user.userEmail]);
    async function getContacts() {
        setLoading(true);
        try {
            const contactData = await GetContactFinepByCompanyAndReference(companyId!, type === "officialContact" ? 0 : 1);
            if (contactData) {
                handleFillTab(2);
                if (contactData.isContentValid) {
                    handleValidateTab(2, 2);
                    setValidateField(true);
                }
                const phones = await GetAllContactPhone(contactData.id ?? "");
                const phoneNumber = phones[0]?.phoneNumber || "";
                setContacts([{
                    ...contactData,
                    phoneNumber,
                    id: contactData.id,
                    isEditing: false,
                    isNew: false
                }]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const originalOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
        if (typeof message === 'string' && message.includes('ResizeObserver')) {
            return true;
        }
        if (originalOnError) {
            return originalOnError(message, source, lineno, colno, error);
        }
        return false;
    };

    const handleInputChange = (field: keyof ContactWithPhone, value: string, id?: string) => {
        if (id) {
            setContacts(contacts.map(contact =>
                contact.id === id ? { ...contact, [field]: value } : contact
            ));
        } else {
            setNewContact(prev => ({ ...prev, [field]: value }));
        }
    };
    const handleAddContact = async () => {
        if (!newContact.fullName || !newContact.email || !newContact.phoneNumber) {
            toast.error("Por favor, preencha Nome, E-mail e Telefone");
            return;
        }
        setLoading(true);
        try {
            const contactToAdd = {
                ...newContact,
                companyFinepId: companyId,
                userEmail: user.userEmail
            };
            const response = await CreateContactFinep(contactToAdd);
            const savedContact = response.data;
            await CreateContactPhoneFinep({
                phoneNumber: newContact.phoneNumber,
                contactFINEPId: savedContact.id,
                isDefault: true,
                userEmail: user.userEmail,
                reference: type === "officialContact" ? 0 : 1
            });
            setContacts([...contacts, {
                ...savedContact,
                phoneNumber: newContact.phoneNumber,
                id: savedContact.id,
                isEditing: false,
                isNew: false
            }]);
            setNewContact({
                fullName: "",
                email: "",
                setor: "",
                department: "",
                phoneNumber: "",
                companyFinepId: companyId || "",
                userEmail: user.userEmail,
                reference: type === "officialContact" ? 0 : 1,
                isContentValid: false,
                contactPhone: 0,
                isNew: true
            });
            toast.success("Contato adicionado com sucesso!");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao adicionar contato");
        } finally {
            setLoading(false);
        }
    };
    const handleEditContact = (id: string) => {
        requestAnimationFrame(() => {
            setContacts(contacts.map(contact =>
                contact.id === id ? { ...contact, isEditing: true } : contact
            ));
        });
    };
    const handleCancelEdit = (id: string) => {
        setContacts(contacts.map(contact =>
            contact.id === id ? { ...contact, isEditing: false } : contact
        ));
    };
    const handleSaveContact = async (id: string) => {
        const contactToUpdate = contacts.find(contact => contact.id === id);
        if (!contactToUpdate) return;

        setLoading(true);

        try {
            await EditContactFinep(contactToUpdate);
            const existingPhones = await GetAllContactPhone(id);
            await Promise.all(existingPhones.map((phone: ContactPhoneFinepModel) =>
                DeleteContactPhoneFinep(phone.id!)
            ));
            await CreateContactPhoneFinep({
                phoneNumber: contactToUpdate.phoneNumber,
                contactFINEPId: id,
                isDefault: true,
                userEmail: user.userEmail,
                reference: type === "officialContact" ? 0 : 1
            });
            setContacts(contacts.map(contact =>
                contact.id === id ? { ...contact, isEditing: false } : contact
            ));
            toast.success("Contato atualizado com sucesso!");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar contato");
        } finally {
            setLoading(false);
        }
    };
    const handleRemoveContact = async (id: string) => {
        setLoading(true);
        try {
            const phones = await GetAllContactPhone(id);
            await Promise.all(phones.map((phone: ContactPhoneFinepModel) =>
                DeleteContactPhoneFinep(phone.id!)
            ));
            const contactToUpdate = contacts.find(c => c.id === id);
            if (contactToUpdate) {
                await EditContactFinep({
                    ...contactToUpdate,
                    isContentValid: false
                })
            }
            setContacts(contacts.filter(contact => contact.id !== id));
            toast.success("Contato removido com sucesso");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao remover contato");
        } finally {
            setLoading(false);
        }
    };
    const columns = [
        {
            title: "Nome Completo",
            dataIndex: "fullName",
            key: "fullName",
            render: (text: string, record: ContactWithPhone) => (
                record.isNew ? (
                    <Input
                        value={newContact.fullName}
                        onChange={(e) => handleInputChange("fullName", e.target.value)}
                        placeholder="Nome completo"
                    />
                ) : record.isEditing ? (
                    <Input
                        value={text}
                        onChange={(e) => handleInputChange("fullName", e.target.value, record.id)}
                        placeholder="Nome completo"
                    />
                ) : (
                    <span>{text}</span>
                )
            )
        },
        {
            title: "E-mail",
            dataIndex: "email",
            key: "email",
            render: (text: string, record: ContactWithPhone) => (
                record.isNew ? (
                    <Input
                        type="email"
                        value={newContact.email}
                        onChange={(e) => handleInputChange("email", e.target.value)}
                        placeholder="E-mail"
                    />
                ) : record.isEditing ? (
                    <Input
                        type="email"
                        value={text}
                        onChange={(e) => handleInputChange("email", e.target.value, record.id)}
                        placeholder="E-mail"
                    />
                ) : (
                    <span>{text}</span>
                )
            )
        },
        {
            title: "Cargo",
            dataIndex: "setor",
            key: "setor",
            render: (text: string, record: ContactWithPhone) => (
                record.isNew ? (
                    <Input
                        value={newContact.setor}
                        onChange={(e) => handleInputChange("setor", e.target.value)}
                        placeholder="Cargo"
                    />
                ) : record.isEditing ? (
                    <Input
                        value={text}
                        onChange={(e) => handleInputChange("setor", e.target.value, record.id)}
                        placeholder="Cargo"
                    />
                ) : (
                    <span>{text}</span>
                )
            )
        },
        {
            title: "Departamento",
            dataIndex: "department",
            key: "department",
            render: (text: string, record: ContactWithPhone) => (
                record.isNew ? (
                    <Input
                        value={newContact.department}
                        onChange={(e) => handleInputChange("department", e.target.value)}
                        placeholder="Departamento"
                    />
                ) : record.isEditing ? (
                    <Input
                        value={text}
                        onChange={(e) => handleInputChange("department", e.target.value, record.id)}
                        placeholder="Departamento"
                    />
                ) : (
                    <span>{text}</span>
                )
            )
        },
        {
            title: "Telefone",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            render: (text: string, record: ContactWithPhone) => (
                record.isNew ? (
                    <Input
                        type="tel"
                        value={newContact.phoneNumber}
                        onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
                        placeholder="Telefone"
                    />
                ) : record.isEditing ? (
                    <Input
                        type="tel"
                        value={text}
                        onChange={(e) => handleInputChange("phoneNumber", e.target.value, record.id)}
                        placeholder="Telefone"
                    />
                ) : (
                    <span>{text}</span>
                )
            )
        },
        {
            title: "Ações",
            key: "actions",
            render: (_: any, record: ContactWithPhone) => (
                <Space size="middle">
                    {record.isNew ? (
                        <Button
                            icon={<PlusCircleOutlined />}
                            type="primary"
                            onClick={handleAddContact}
                            loading={loading}
                        >
                            Adicionar
                        </Button>
                    ) : record.isEditing ? (
                        <>
                            <Button
                                icon={<SaveOutlined style={{ color: "#389E0D" }} />}
                                type="text"
                                onClick={() => handleSaveContact(record.id!)}
                            />
                            <Button
                                icon={<CloseOutlined />}
                                type="text"
                                onClick={() => handleCancelEdit(record.id!)}
                            />
                            <Popconfirm
                                title="Tem certeza que deseja excluir?"
                                onConfirm={() => handleRemoveContact(record.id!)}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button
                                    icon={<DeleteOutlined style={{ color: "#CF1322" }} />}
                                    type="text"
                                />
                            </Popconfirm>
                        </>
                    ) : (
                        <>
                            <Button
                                icon={<EditOutlined style={{ color: "#0958D9" }} />}
                                type="text"
                                onClick={() => handleEditContact(record.id!)}
                            />
                            <Popconfirm
                                title="Tem certeza que deseja excluir?"
                                onConfirm={() => handleRemoveContact(record.id!)}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button
                                    icon={<DeleteOutlined style={{ color: "#CF1322" }} />}
                                    type="text"
                                />
                            </Popconfirm>
                        </>
                    )}
                </Space>
            )
        }
    ];

    return (
        <>
            {loading && <Loader />}
            <div style={{ minWidth: '100%', overflow: 'auto' }}>
                <Form>
                    <Table
                        dataSource={[...contacts, newContact]}
                        columns={columns}
                        rowKey={(record) => record.id ? record.id : "new-contact"}
                        pagination={false}
                    />
                </Form>
            </div>
        </>
    );
};
export default ContactPartial;